import { Injectable, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { ConfigService } from './config.service';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  UserLoginDetails: any;
  userObj: any;
  tokanExpiredFlag: boolean = false;
  aadhar_card = ('^[2-9][0-9]{11}$');
  panValidation = '[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}';
  @ViewChild('sessionModalOpen') sessionModalOpen: any;
  key: string = '8080808080808080';

  getBaseurl(url: string) {
    return this.configService.baseUrls(url)
  }

  private httpObj: any = {
    type: '',
    url: '',
    options: Object
  };
  clearHttp() {
    this.httpObj.type = '';
    this.httpObj.url = '';
    this.httpObj.options = {};
  }
  constructor(private http: HttpClient, private datepipe: DatePipe, private router: Router, private spinner: NgxSpinnerService,
    private toastrService: ToastrService, private configService: ConfigService
  ) {

  }

  getsessionStorageData() {
    try {
      let raw = sessionStorage.getItem('loggedInDetails');
      if (raw) {
        let loginObj = JSON.parse(raw)?.responseData?.[0];
        return loginObj || {};
      }
    } catch (e) { }
    return {};
  }

  checkUserIsLoggedIn() {
    if (sessionStorage.getItem('loggedInDetails')) {
      return true
    }
    else return false
  }

  encryptUsingAES256(data: any) {
    let _key = CryptoJS.enc.Utf8?.parse(this.key);
    let _iv = CryptoJS.enc.Utf8?.parse(this.key);
    let encrypted = CryptoJS.AES?.encrypt(
      data, _key, {
      keySize: 256 / 8,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }

  decryptUsingAES256(data: any) {
    let _key = CryptoJS.enc.Utf8?.parse(this.key);
    let _iv = CryptoJS.enc.Utf8?.parse(this.key);
    return CryptoJS.AES?.decrypt(
      data, _key, {
      keySize: 256 / 8,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
  }


  userRole() { // get user role name from sessionStorage
    let userType = this.getsessionStorageData();
    return userType.userType;
  }

  loggedInUserId() {
    let userId = this.getsessionStorageData();
    return userId.id;
  }

  userProfileName$ = new Subject<string>();

  updateSessionUserName(newName: string) {
    if (!newName) return;
    const updateName = (storage: Storage) => {
      try {
        let rawData = storage.getItem('loggedInDetails');
        if (rawData) {
          let loggedData: any = JSON.parse(rawData);
          if (loggedData?.responseData?.[0]) {
            loggedData.responseData[0].name = newName;
            storage.setItem('loggedInDetails', JSON.stringify(loggedData));
          }
        }
      } catch (e) { }
    };
    updateName(sessionStorage);
    updateName(localStorage);
    this.userProfileName$.next(newName);
  }

  updateSessionKycDetails(data: any) {
    if (!data) return;
    const updateTarget = (storage: Storage) => {
      try {
        let rawData = storage.getItem('loggedInDetails');
        if (rawData) {
          let loggedData: any = JSON.parse(rawData);
          if (loggedData?.responseData?.[0]) {
            const user = loggedData.responseData[0];
            if (data.isKycRequired !== undefined) {
              user.isKycRequired = data.isKycRequired;
            }
            if (data.isPanKycRequired !== undefined) {
              user.isPanKycRequired = data.isPanKycRequired;
            }
            if (data.isAdharKycRequired !== undefined) {
              user.isAdharKycRequired = data.isAdharKycRequired;
            }
            if (data.isGSTKycRequired !== undefined) {
              user.isGSTKycRequired = data.isGSTKycRequired;
            }
            if (data.isKycVerified !== undefined) {
              user.isKycVerified = data.isKycVerified;
            }
            storage.setItem('loggedInDetails', JSON.stringify(loggedData));
          }
        }
      } catch (e) { }
    };

    updateTarget(sessionStorage);
    updateTarget(localStorage);
  }

  loggedInUsername() {
    let userName = this.getsessionStorageData();
    return userName.name;
  }

  loggedInUserMobile() {
    let usermobileNo = this.getsessionStorageData();
    return usermobileNo.mobileNo1
  }

  getVehicleInfo() {
    let VehicleInfo = this.getsessionStorageData();
    return VehicleInfo
  }

  getVehicleOwnerId() {
    let vehOwnerId = this.getsessionStorageData();
    return vehOwnerId.vehicleOwnerId
  }

  // getVehicleOwnerId() {
  //   let vehOwnerId = 158477;
  //   return vehOwnerId
  // }


  getVehicleOwnerMobileNo() {
    let vehOwnerId = this.getsessionStorageData();
    return vehOwnerId.vehicleOwnerMobileNo
  }

  tokenExpireDateTime() {
    let loginObj = JSON.parse(sessionStorage.loggedInDetails).responseData3;
    return loginObj.accessTokenExpires;
    // return vehOwnerId.vehicleOwnerId
  }

  tokenExpireRefreshString() {
    let loginObj = JSON.parse(sessionStorage.loggedInDetails).responseData3;
    return loginObj.refreshToken.tokenString;
    // return vehOwnerId.vehicleOwnerId
  }

  getHttp(): any {
    let temp: any = undefined;
    !this.httpObj.options.body && (delete this.httpObj.options.body)
    !this.httpObj.options.params && (delete this.httpObj.options.params)
    return this.http.request(this.httpObj.type, this.httpObj.url, this.httpObj.options);
  }

  setHttp(type: string, url: string, isHeader: Boolean, obj: any, params: any, baseUrl: any) {
    // isHeader = false;
    // check user is login or not
    let checkLOginData = sessionStorage.getItem('loggedInDetails');
    if (checkLOginData && this.tokanExpiredFlag == false && isHeader) {
      let tokenExp = JSON.parse(checkLOginData);
      let expireAccessToken: any = (Math.round(new Date(tokenExp.responseData3.expireAccessToken).getTime() / 1000));
      let tokenExpireDateTime: any = (Math.round(new Date(tokenExp.responseData3.refreshToken.expireAt).getTime() / 1000));
      let currentDateTime: any = (Math.round(new Date().getTime() / 1000));
      if (currentDateTime >= expireAccessToken) {
        if (currentDateTime <= tokenExpireDateTime) {
          // this.tokanExpiredFlag = true
          let obj = {
            UserId: this.loggedInUserId(),
            RefreshToken: this.tokenExpireRefreshString()
          }
          //this.tokenExpiredAndRefresh(obj);
        } else {
          this.spinner.hide();
          sessionStorage.clear();
          this.router.navigate(['/login']);
          this.toastrService.info('Your Session Has Expired. Please Re-Login Again.');
          return
          //this.UserLoginDetails = JSON.parse(sessionStorage.loggedInDetails);
          // this.tokanExpiredFlag = true

        }

      }
    }

    try {
      this.userObj = JSON.parse(sessionStorage.loggedInDetails);
      // this.UserLoginDetails = JSON.parse(sessionStorage.loggedInDetails);
    } catch (e) { }
    this.clearHttp();
    this.httpObj.type = type;
    this.httpObj.url = this.getBaseurl(baseUrl) + url;
    if (isHeader) {
      let tempObj: any = {
        "Authorization": "Bearer " + this.userObj.responseData3.accessToken, // token set
        'userId': "" + this.encryptUsingAES256(JSON.stringify(this.loggedInUserId()))
      };
      // if (this.UserLoginDetails && type !== 'get') {
      //   tempObj.UserId = this.UserLoginDetails.responseData[0].id;
      //   tempObj.UserType = this.UserLoginDetails.responseData[0].userType;
      // }
      this.httpObj.options.headers = new HttpHeaders(tempObj);
    }

    if (obj !== false) {
      this.httpObj.options.body = obj;
    }
    else {
      this.httpObj.options.body = false;
    }
    if (params !== false) {
      this.httpObj.options.params = params;
    }
    else {
      this.httpObj.options.params = false;
    }
  }

  getAddress(cr: any, i: any) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        let geocoder: any = new google.maps.Geocoder;
        var latlng = { lat: parseFloat(cr.latitude), lng: parseFloat(cr.longitude) };
        geocoder === undefined && (geocoder = new google.maps.Geocoder())
        geocoder.geocode({ 'location': latlng }, (results: any, status: any) => {
          let tempObj: any = new Object();
          tempObj = { ...cr }
          Object.keys(cr).map(function (p) { tempObj[p] = cr[p]; });
          if (status === 'OK') {
            if (results[0]) {
              var address = results.length === 0 ? "Unknown location" : results[0].formatted_address;
              tempObj.address = address;
              resolve(tempObj);
            } else {
              tempObj.address = "Unknown location";
              resolve(tempObj);
            }
          } else {
            tempObj.address = "Unknown location";
            resolve(tempObj);
          }
        })
      }, 200 * i)
    });
  }

  tokenExpiredAndRefresh(obj: any) {
    let callRefreshTokenAPI = this.http.post('http://audit-mahaservice.harmining.com/vehicle-tracking/login/refresh-token', obj);
    callRefreshTokenAPI.subscribe((res: any) => {
      if (res.statusCode === "200") {
        let loginObj: any = sessionStorage.getItem('loggedInDetails');
        loginObj = JSON.parse(loginObj);
        loginObj.responseData3 = res.responseData;
        sessionStorage.setItem('loggedInDetails', JSON.stringify(loginObj));
        this.tokanExpiredFlag = false;
      }
      else if (res.statusCode === "409") {
        this.spinner.hide();
      }
      else {
        this.spinner.hide();
        sessionStorage.clear();
        this.router.navigate(['/login']);
        this.toastrService.info('Your Session Has Expired. Please Re-Login Again.')
        //this.UserLoginDetails = JSON.parse(sessionStorage.loggedInDetails);
      }
    })
  }

  convertTime12to24(time12h: any) {
    const [time, modifier] = time12h.split(' ');
    let [hours, minutes] = time.split(':');
    if (hours === '12') {
      hours = '00';
    }
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}`;
  }

  checkEmptyData(data: any) {
    let value: any;
    if (data == "" || data == null || data == "null" || data == undefined || data == "undefined" || data == 'string' || data == null || data == 0 || data == "0001-01-01T00:00:00") {
      value = false;
    } else {
      value = true;
    }
    return value;
  }

  validateAadhaar(aadhaarNumber: string): boolean {
    if (!aadhaarNumber) return false;
    const aadhaarRegex = new RegExp("^[2-9]{1}[0-9]{11}$");
    // Basic format check
    if (!aadhaarRegex.test(aadhaarNumber)) {
      return false;
    }

    // Verhoeff algorithm tables
    const d = [
      [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
      [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
      [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
      [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
      [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
      [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
      [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
      [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
      [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]
    ];

    const p = [
      [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
      [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
      [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
      [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
      [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
      [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
      [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]
    ];

    let c = 0;
    const reversedDigits = aadhaarNumber.split('').reverse().map(digit => parseInt(digit, 10));

    for (let i = 0; i < reversedDigits.length; i++) {
      c = d[c][p[i % 8][reversedDigits[i]]];
    }

    return c === 0;
  }

  aadhaarValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const isValid = this.validateAadhaar(control.value.toString());
      return isValid ? null : { pattern: true, invalidAadhaar: true };
    };
  }
}

